import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Loader, Toggle } from '@driftt/tide-core-legacy'
import { patchOperations } from 'utils/PatchHelper'

import * as OrgActions from 'app/modules/org/actions'
import * as OrgSelectors from 'app/modules/org/selectors'

import './style.styl'

const SALESFORCE_REVENUE_ORG_PROPERTY = 'salesforceRevenueMetricsEnabled'

class RevenueDashboardToggle extends Component {
  state = {
    isToggled: this.props.hasSalesforceRevenueEnabled
  }

  componentWillUpdate(nextProps) {
    if (nextProps.hasSalesforceRevenueEnabled !== this.props.hasSalesforceRevenueEnabled) {
      this.setState({ isToggled: nextProps.hasSalesforceRevenueEnabled })
    }
  }

  toggleRevenueDashboard = () => {
    const { isToggled } = this.state

    const patchedProperties = patchOperations({
      [[SALESFORCE_REVENUE_ORG_PROPERTY]] : !isToggled
    })

    this.props.actions.patchOrgProperties(patchedProperties)
    this.setState({ isToggled: !isToggled })
  }

  render() {
    const { isToggled } = this.state
    const { hasSalesforceRevenueEnabled } = this.props

    return (
      <div className="salesforce-revenue-setting">
        { _.isUndefined(hasSalesforceRevenueEnabled) &&
          <Loader/>
        }
        { !_.isUndefined(hasSalesforceRevenueEnabled) &&
          <div>
            <h2 className="integration-section-title">
              Salesforce Revenue Dashboard
            </h2>
            <div className="salesforce-revenue-toggle">
              <p className="salesforce-revenue-description">
                Your Salesforce Revenue Dashboard helps you understand exactly how much Drift is helping your business.
              </p>
              <Toggle
                checked={isToggled}
                onChange={this.toggleRevenueDashboard}
              />
            </div>
          </div>
        }
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      patchOrgProperties: OrgActions.patchOrgProperties
    },
    dispatch
  )
})

const mapStateToProps = state => {
  return {
    hasSalesforceRevenueEnabled: OrgSelectors.properties(state)[SALESFORCE_REVENUE_ORG_PROPERTY]
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RevenueDashboardToggle)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/RevenueDashboardToggle/index.js